import { HttpClient } from "@angular/common/http";
import { RecaptchaResponse } from "../model/RecaptchaResponse";
import { Observable } from "rxjs";
import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";

@Injectable()
export class RecaptchaVerifyService {
    private url = environment.server + environment.app + environment.api_recaptcha;
    
    constructor(private http: HttpClient) {
    }

    verifyRecaptchaCode(token: string): Observable<RecaptchaResponse>{
        const url = `${this.url}response`;
        return this.http.post<RecaptchaResponse>(url, token);
    }

}